export interface AffiliateUserSummary {
  userID: number;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  affiliateCode: string;
  affiliateEnabled: boolean;
  totalClicks: number;
  totalUniqueClicks: number;
  totalOrders: number;
  totalRevenue: number;
}

export const affiliateUserSummaryFromResponse = (
  responseData: any,
): AffiliateUserSummary => ({
  userID: responseData.user_id,
  firstName: responseData.first_name,
  lastName: responseData.last_name,
  email: responseData.email,
  phone: responseData.phone,
  affiliateCode: responseData.affiliate_code,
  affiliateEnabled: responseData.affiliate_enabled,
  totalClicks: responseData.total_clicks,
  totalUniqueClicks: responseData.total_unique_clicks,
  totalOrders: responseData.total_orders,
  totalRevenue: responseData.total_revenue,
});
